module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "poem3",
    attrs: {
      "id": "epigraph"
    }
  }, [_c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('i', [_vm._v("Parlez moi d’amour,")])])]), _c('a', {
    attrs: {
      "id": "start"
    }
  }, [_c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Redites, moi des choses tendres.")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Votre beau discours,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Mon coeur n’est pas las de l’entendre…")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Pourvu que toujours vous répétiez ces mots suprêmes,")])]), _vm._v(" "), _c('p', {
    staticClass: "poem3"
  }, [_c('i', [_vm._v("Je vous aime…")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6757b723","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/5epigraph.vue
// module id = 75
// module chunks = 0